import React, { useMemo, useState } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleOpportunityTypeDetails = () => {
  const { typeId } = useParams();
  const navigate = useNavigate();
  const { showToast } = React.useContext(ToastContext);

  const decodedId = typeId ? atob(typeId) : typeId;
  const id = decodedId.replace(/\D/g, '');

  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['opportunityType']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['opportunityType'] + id + '/', { headers });
      showToast('Opportunity Type deleted successfully', 'success');
      navigate('/opportunity/type/list');
    } catch (error) {
      console.error('Error deleting Opportunity Type:', error);
      showToast('Error deleting Opportunity Type', 'error');
    }
    setShowDelete(false);
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        entityName="Opportunity Type"
        listPath="/opportunity/type/list"
        editPath={`/opportunity/type/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
        loading={loading}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Opportunity Type"
        message="Are you sure you want to delete this Opportunity Type?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleOpportunityTypeDetails;
